<template>
  <v-avatar
    color="#333"
    size="40"
    class=" align-center"
    :data-id-row="item.id"
    :class="['avatar', { hidden: isSelected }]"
  >
    <template>
      <div
        style="width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;"
        v-if="item.avatar && !isErrorLoading && item.isSvg"
      >
        <v-img
          width="25"
          height="25"
          style="flex: initial;"
          @error="handleError"
          :src="item.avatar"
        />
      </div>
      <v-img
        cover
        v-else-if="item.avatar && !isErrorLoading && !item.isSvg"
        width="40"
        height="40"
        @error="handleError"
        :src="item.avatar"
      />
      <span v-else-if="item.login" class="white--text headline avatar_text">
        {{ getLetters(item.login).toUpperCase() }}
      </span>

      <v-icon color="white" v-else>{{ item.iconFallback }}</v-icon>
    </template>
  </v-avatar>
</template>

<script>
export default {
  name: 'AvatarItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    checkAvatar(v) {
      return v.indexOf('mdi') > -1 ? 'icon' : 'avatar';
    },
    getLetters(v) {
      return v
        .split(' ')
        .map(i => i[0])
        .join('');
    },
    handleError() {
      this.isErrorLoading = true;
    }
  },
  data() {
    return {
      isErrorLoading: false
    };
  }
};
</script>

<style scoped>
.change-color {
  filter: brightness(0) invert(0%);
}
</style>
